import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://email-query-api.your-subdomain.workers.dev';
const API_KEY = process.env.REACT_APP_API_KEY;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    ...(API_KEY && { 'x-api-key': API_KEY }),
  },
});

export interface EmailItem {
  message_id: string;
  from: string;
  to: string;
  subject: string;
  text: string;
  timestamp: string;
  created_at: string;
  has_html: boolean;
  has_attachments: boolean;
}

export interface EmailDetail extends EmailItem {
  html: string;
  attachments: Array<{
    filename: string;
    contentType: string;
    size: number;
  }>;
}

export interface EmailListResponse {
  items: EmailItem[];
  count: number;
}

export const emailService = {
  getEmails: async (params?: {
    limit?: number;
    sender?: string;
    subject?: string;
  }): Promise<EmailListResponse> => {
    const response = await api.get<EmailListResponse>('/emails', { params });
    return response.data;
  },

  getEmail: async (messageId: string): Promise<EmailDetail> => {
    const response = await api.get<EmailDetail>(`/emails/${encodeURIComponent(messageId)}`);
    return response.data;
  },
};

